export default __webpack_public_path__ + "static/media/calendar.73326059.svg";